import Container from "../components/Container";
import chipsMockup from "../assets/hs_1oz_mockup_nobg.png";
import balmMockup from "../assets/mockup_balm.png";

import chipsLogo from "../assets/TTC_logo.png";
import balmLogo from "../assets/TTB_logo.png";

export default function Products() {
  return (
    <section
      id="products"
      className="bg-brand-light min-h-screen flex items-center py-24 md:py-0"
    >
      <Container>
        <div className="max-w-7xl mx-auto">
          
          <h2 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-extrabold mb-16 text-center">
            Our Brands
          </h2>

          <div className="grid md:grid-cols-2 gap-12">
            
            {/* Tallow Chips */}
            <a
              href="https://teddystallowchips.com"
              className="group bg-white px-10 sm:px-14 py-14 sm:py-16 rounded-3xl shadow-sm hover:shadow-lg transition flex flex-col items-center text-center"
            >
              <img
                src={chipsLogo}
                alt="Teddy’s Tallow Chips Logo"
                className="h-32 sm:h-36 mb-6 object-contain"
              />

              <h3 className="text-3xl md:text-4xl font-semibold mb-4">
                Teddy’s Tallow Chips
              </h3>

              <p className="text-lg md:text-xl text-gray-700 mb-8 max-w-md">
                Tallow cooked snacks made the right way.
              </p>

              <img
                src={chipsMockup}
                alt="Teddy’s Tallow Chips"
                className="w-60 sm:w-72 md:w-80 object-contain mb-10"
              />

              <span className="inline-block px-8 py-4 border border-black rounded-full text-base font-medium group-hover:bg-black group-hover:text-white transition">
                Go to site →
              </span>
            </a>

            {/* Tallow Balm */}
            <a
              href="https://teddystallowbalm.com"
              className="group bg-white px-10 sm:px-14 py-14 sm:py-16 rounded-3xl shadow-sm hover:shadow-lg transition flex flex-col items-center text-center"
            >
              <img
                src={balmLogo}
                alt="Teddy’s Tallow Balm Logo"
                className="h-32 sm:h-36 mb-6 object-contain"
              />

              <h3 className="text-3xl md:text-4xl font-semibold mb-4">
                Teddy’s Tallow Balm
              </h3>

              <p className="text-lg md:text-xl text-gray-700 mb-8 max-w-md">
                Minimal ingredient tallow based skincare.
              </p>

              <img
                src={balmMockup}
                alt="Teddy’s Tallow Balm"
                className="w-60 sm:w-72 md:w-80 object-contain rounded-xl mb-10"
              />

              <span className="inline-block px-8 py-4 border border-black rounded-full text-base font-medium group-hover:bg-black group-hover:text-white transition">
                Go to site →
              </span>
            </a>

          </div>
        </div>
      </Container>
    </section>
  );
}
